/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/CommonTypes.yaml
/** @hidden */
export const ProcessingModeValues = ['LIVE', 'SINGLE_SHOT', 'AUTO'];
//# sourceMappingURL=CommonTypes.js.map